<template>
  <span class="tw-text-4xl tw-font-medium tw-text-primary-grey-800">
    <slot />
  </span>
</template>
